{
  "page": {
    "title": "Suivi des expéditions",
    "subtitle": "Suivez les expéditions en cours, gérez les RTS et relancez les erreurs de suivi.",
    "tabsAria": "Onglets des expéditions",
    "panelAria": "Panneau {{tab}}",
    "loadFailed": "Échec du chargement de la liste des expéditions."
  },
  "common": {
    "networkError": "Erreur réseau - vérifiez la connexion",
    "loading": "Chargement des expéditions..."
  },
  "tabLabels": {
    "in_transit": "En transit",
    "rts": "File RTS",
    "errors": "Erreurs de suivi"
  },
  "filters": {
    "ariaLabel": "Filtres des expéditions",
    "carrier": "Transporteur",
    "carrierAll": "— Tous —",
    "search": "Rechercher (commande # ou suivi #)",
    "searchPlaceholder": "PWO… ou numéro de suivi",
    "vendorId": "ID fournisseur",
    "dateFrom": "Date de début",
    "dateTo": "Date de fin",
    "apply": "Appliquer",
    "reset": "Effacer les filtres",
    "reload": "Recharger",
    "validation": {
      "invalidDate": "Saisissez une date et une heure valides.",
      "dateRange": "La date de début doit précéder ou être égale à la date de fin."
    }
  },
  "inTransit": {
    "loading": "Chargement des expéditions...",
    "empty": "Aucune expédition en transit.",
    "columns": {
      "tracking": "Suivi #",
      "carrier": "Transporteur",
      "status": "Statut",
      "vendor": "Fournisseur",
      "eta": "ETA",
      "firstScan": "Premier scan",
      "delivered": "Livré",
      "updated": "Mis à jour",
      "order": "Commande",
      "actions": "Actions"
    }
  },
  "status": {
    "stale": "Obsolète"
  },
  "refresh": {
    "aria": "Actualiser le suivi",
    "loading": "Actualisation du suivi…",
    "success": "Suivi actualisé",
    "terminalTooltip": "Livraison terminée — aucune actualisation nécessaire",
    "errors": {
      "noPerm": "Vous n'avez pas la permission d'actualiser le suivi",
      "notFound": "Colis introuvable",
      "quotaExceeded": "Limite d'actualisation du suivi atteinte — réessayez plus tard",
      "carrierDown": "Transporteur temporairement indisponible — réessayez plus tard",
      "generic": "Impossible d'actualiser le suivi"
    }
  },
  "rtsQueue": {
    "loading": "Chargement de la file RTS...",
    "empty": "Aucune commande dans la file RTS.",
    "columns": {
      "order": "Commande",
      "merchant": "Marchand",
      "vendor": "Fournisseur",
      "returnReason": "Motif du retour",
      "returnedAt": "Date du retour",
      "actions": "Actions"
    },
    "actions": {
      "shipAgain": "Réexpédier",
      "refund": "Rembourser",
      "openTicket": "Ouvrir un ticket",
      "unavailable": "Pas encore disponible — les remboursements et réexpéditions ne sont pas traités automatiquement. Traitez ce retour manuellement."
    }
  },
  "trackingErrors": {
    "loading": "Chargement des erreurs de suivi...",
    "empty": "Aucune commande avec erreur de suivi.",
    "columns": {
      "order": "Commande",
      "tracking": "Suivi #",
      "carrier": "Transporteur",
      "lastFetch": "Dernière récupération",
      "failures": "Échecs",
      "error": "Erreur",
      "actions": "Actions"
    },
    "retry": "Réessayer",
    "retrying": "Tentative...",
    "toast": {
      "notAccepted": "Demande de nouvelle tentative non acceptée",
      "queuedTitle": "Nouvelle tentative mise en file",
      "queuedDesc": "Commande {{orderNumber}} → le transporteur réessaiera."
    }
  },
  "shipAgain": {
    "dialogAria": "Réexpédier vers une nouvelle adresse",
    "title": "Réexpédier — commande {{orderNumber}}",
    "description": "Saisissez une nouvelle adresse. Les frais d'expédition sont débités du portefeuille du marchand. Le fournisseur créera un nouveau traitement.",
    "fields": {
      "fullName": "Nom complet du destinataire *",
      "line1": "Adresse ligne 1 *",
      "line2": "Adresse ligne 2",
      "city": "Ville *",
      "state": "État / Province",
      "postalCode": "Code postal *",
      "country": "Pays (ISO-2) *",
      "phone": "Numéro de téléphone",
      "note": "Note"
    },
    "cancel": "Annuler",
    "submit": "Réexpédier",
    "submitting": "Envoi en cours...",
    "toast": {
      "notAccepted": "Demande de réexpédition non acceptée",
      "queuedTitle": "Réexpédition mise en file",
      "queuedDesc": "Commande {{orderNumber}} → nouveau traitement en file."
    }
  },
  "refund": {
    "dialogAria": "Rembourser la commande",
    "title": "Rembourser — commande {{orderNumber}}",
    "description": "Remboursement vers le portefeuille du marchand. Vous pouvez éventuellement indemniser le fournisseur depuis le portefeuille de la plateforme.",
    "fields": {
      "amount": "Montant du remboursement (USD) *",
      "reason": "Motif *",
      "justification": "Justification * (au moins 10 caractères)",
      "vendorComp": "Indemnisation du fournisseur (USD, facultatif)"
    },
    "reasons": {
      "SHIPPING_LOST": "Colis perdu / manquant",
      "CUSTOMER_DISSATISFACTION": "Insatisfaction du client",
      "QUALITY_DEFECT": "Défaut de qualité",
      "WRONG_ADDRESS": "Mauvaise adresse",
      "CARRIER_RETURN": "Retour du transporteur",
      "OTHER": "Autre"
    },
    "validation": {
      "amountInvalid": "Le montant doit être supérieur à 0.",
      "justificationTooShort": "La justification doit comporter au moins 10 caractères."
    },
    "cancel": "Annuler",
    "submit": "Rembourser",
    "submitting": "Envoi en cours...",
    "toast": {
      "notAccepted": "Demande de remboursement non acceptée",
      "queuedTitle": "Remboursement mis en file",
      "queuedDesc": "Commande {{orderNumber}} → remboursement de {{amount}}."
    }
  },
  "openTicket": {
    "dialogAria": "Ouvrir un ticket de support",
    "title": "Ouvrir un ticket — commande {{orderNumber}}",
    "description": "Créez un ticket de support lié à cette commande. Le marchand sera notifié.",
    "fields": {
      "subject": "Sujet (facultatif)",
      "body": "Contenu *",
      "priority": "Priorité *",
      "category": "Catégorie *"
    },
    "priorities": {
      "LOW": "Basse",
      "NORMAL": "Normale",
      "HIGH": "Haute",
      "URGENT": "Urgente"
    },
    "validation": {
      "bodyRequired": "Le contenu du ticket est requis."
    },
    "cancel": "Annuler",
    "submit": "Ouvrir un ticket",
    "submitting": "Envoi en cours...",
    "toast": {
      "notAccepted": "Demande d'ouverture de ticket non acceptée",
      "queuedTitle": "Ticket mis en file",
      "queuedDesc": "Commande {{orderNumber}} → ticket de priorité {{priority}}."
    }
  },
  "_vgBinding": "vg-binding: P4.11.D-29,P4.11.D-30,P4.11.D-31,P4.11.D-32 — i18n keys for In Transit First Scan/Delivered/Actions columns + stale badge label (status.stale, enum VALUE stays English) across en/vi/fr [task-18]"
}
